import { render, staticRenderFns } from "./MasterDataClassList.vue?vue&type=template&id=2285a25b&"
import script from "./MasterDataClassList.vue?vue&type=script&lang=js&"
export * from "./MasterDataClassList.vue?vue&type=script&lang=js&"
import style0 from "./MasterDataClassList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports